import React, { useState } from 'react';
import { FaUtensils, FaDrumstickBite, FaSeedling, FaIceCream, FaFilePdf, FaDownload } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const Menu = () => {
  const { t } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState(0);

  const menuCategories = [
    {
      icon: <FaUtensils className="text-5xl text-marrakech-gold" />,
      titleKey: 'menu.appetizers',
      items: [
        { nameKey: 'menu.saladeMorocaine', price: '195 MAD' },
        { nameKey: 'menu.pastillaPoultry', price: '180 MAD' },
        { nameKey: 'menu.pastillaMer', price: '210 MAD' },
        { nameKey: 'menu.briouates', price: '190 MAD' },
        { nameKey: 'menu.saladeBurrata', price: '210 MAD' },
        { nameKey: 'menu.nemsVegetariens', price: '190 MAD' },
      ],
    },
    {
      icon: <FaDrumstickBite className="text-5xl text-marrakech-gold" />,
      titleKey: 'menu.mainCourses',
      items: [
        { nameKey: 'menu.tanjia', price: '280 MAD' },
        { nameKey: 'menu.taginePoultry', price: '245 MAD' },
        { nameKey: 'menu.tagineBeef', price: '260 MAD' },
        { nameKey: 'menu.tagineBeefPrunes', price: '260 MAD' },
        { nameKey: 'menu.tagineVeal', price: '260 MAD' },
        { nameKey: 'menu.tagineVealPrunes', price: '260 MAD' },
        { nameKey: 'menu.tagineVegetarian', price: '240 MAD' },
        { nameKey: 'menu.couscousVegetarian', price: '220 MAD' },
        { nameKey: 'menu.couscousBeef', price: '260 MAD' },
        { nameKey: 'menu.couscousPoultry', price: '245 MAD' },
        { nameKey: 'menu.couscousVeal', price: '260 MAD' },
        { nameKey: 'menu.couscousMerguez', price: '240 MAD' },
        { nameKey: 'menu.couscousRoyal', price: '290 MAD' },
        { nameKey: 'menu.filetBeef', price: '320 MAD' },
        { nameKey: 'menu.paveSalmon', price: '280 MAD' },
      ],
    },
    {
      icon: <FaIceCream className="text-5xl text-marrakech-gold" />,
      titleKey: 'menu.desserts',
      items: [
        { nameKey: 'menu.fondantChocolate', price: '120 MAD' },
        { nameKey: 'menu.fruitSalad', price: '120 MAD' },
        { nameKey: 'menu.frenchToast', price: '120 MAD' },
        { nameKey: 'menu.orangeSalad', price: '120 MAD' },
      ],
    },
    {
      icon: <FaSeedling className="text-5xl text-marrakech-gold" />,
      titleKey: 'menu.specialMenus',
      items: [
        {
          nameKey: 'menu.menuDiscovery',
          price: '500 MAD',
          isSpecial: true,
          courses: [
            {
              titleKey: 'menu.appetizersChoice',
              optionKeys: [
                'menu.saladeMorocaine',
                'menu.briouates',
                'menu.nemsVegetariens'
              ]
            },
            {
              titleKey: 'menu.firstCourseChoice',
              optionKeys: [
                'menu.taginePoultry',
                'menu.tagineBeefPrunes',
                'menu.tagineVegetarian'
              ]
            },
            {
              titleKey: 'menu.secondCourseTable',
              optionKeys: [
                'menu.couscousVegetarian',
                'menu.couscousPoultry'
              ]
            },
            {
              titleKey: 'menu.dessertChoice',
              optionKeys: [
                'menu.fondantChocolate',
                'menu.orangeSalad',
                'menu.fruitSalad'
              ]
            }
          ]
        },
        {
          nameKey: 'menu.menuChild',
          price: '150 MAD',
          isSpecial: true,
          courses: [
            {
              titleKey: 'menu.dishChoice',
              optionKeys: [
                'menu.couscousPoultry',
                'menu.steakFries'
              ]
            },
            {
              titleKey: 'menu.dessertChoice',
              optionKeys: [
                'menu.iceCreamBall',
                'menu.fondantChocolate'
              ]
            }
          ]
        }
      ],
    },
  ];

  return (
    <div className="menu">
      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center parallax overlay"
        style={{
          backgroundImage: 'url(/images/DSC08503.webp)',
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-elegant font-bold mb-4" data-aos="fade-up">
            {t('menu.title')}
          </h1>
          <p className="text-xl md:text-2xl" data-aos="fade-up" data-aos-delay="100">
            {t('menu.subtitle')}
          </p>

         
        </div>
      </section>

      {/* Introduction */}
      

      {/* Menu Categories - Modern Design */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-16" data-aos="fade-up">
            {menuCategories.map((category, index) => (
              <button
                key={index}
                onClick={() => setSelectedCategory(index)}
                className={`px-6 py-3 rounded-full font-bold transition-all duration-300 flex items-center gap-2 ${
                  selectedCategory === index
                    ? 'bg-[#72201e] text-white shadow-lg scale-105'
                    : 'bg-[#eee1ca] text-black hover:bg-[#72201e] hover:text-white'
                }`}
              >
                {/* <spam className="hidden sm:block">
                {category.icon}
                </spam> */}
                <span className="">{t(category.titleKey)}</span>
              </button>
            ))}
            <a href="/files/jana-menu-nouvel-an.pdf" target="_blank" rel="noopener noreferrer"
                key={menuCategories.length+1}

                className={`px-6 py-3 rounded-full font-bold transition-all duration-300 flex items-center gap-2 bg-[#eee1ca] text-black hover:bg-[#72201e] hover:text-white
                `}
              >

                <span className="">{t('menu.nouvelAnTitle')}</span>
              </a>
          </div>

          {/* Menu Items Display */}
          <div data-aos="fade-up" className="max-w-4xl mx-auto">
            <div className=" rounded-2xl  p-8 md:p-12">
              <h2 className="text-4xl md:text-5xl font-elegant font-bold text-marrakech-dark mb-2 text-center">
                {t(menuCategories[selectedCategory].titleKey)}
              </h2>
              <div className="w-24 h-1 bg-[#72201e] mx-auto mb-8"></div>

              <div className="space-y-6">
                {menuCategories[selectedCategory].items.map((item, itemIndex) => (
                  <div key={itemIndex}>
                    {item.isSpecial ? (
                      // Special Menu Display
                      <div className="rounded-xl p-6">
                        <div className="flex justify-between items-center mb-6">
                          <h4 className="text-2xl font-bold text-marrakech-dark">
                            {t(item.nameKey)}
                          </h4>
                          <span className="text-2xl font-bold text-[#72201e]">
                            {item.price}
                          </span>
                        </div>

                        <div className="space-y-4">
                          {item.courses.map((course, courseIndex) => (
                            <div key={courseIndex} className="bg-white rounded-lg p-4 border-l-4 border-[#72201e]">
                              <h5 className="font-bold text-marrakech-dark mb-3 text-lg">
                                {t(course.titleKey)}
                              </h5>
                              <ul className="space-y-2">
                                {course.optionKeys.map((optionKey, optionIndex) => (
                                  <li key={optionIndex} className="text-[#72201e] flex items-start">
                                    <span className="text-marrakech-terracotta mr-3 font-bold">•</span>
                                    <span>{t(optionKey)}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      // Regular Menu Item Display
                      <div className="border-b-2 border-[#72201e] pb-4 hover:transform hover:translate-x-2 transition-transform duration-300">
                        <div className="flex justify-between items-start gap-4">
                          <div className="flex-1">
                            <h4 className="text-lg font-bold text-black">
                              {t(item.nameKey)}
                            </h4>
                            {item.description && (
                              <p className="text-sm text-marrakech-clay mt-2 leading-relaxed">
                                {item.description}
                              </p>
                            )}
                          </div>
                          <span className="text-[#72201e] font-bold whitespace-nowrap ml-4">
                            {item.price}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Special Features */}
      <section className="py-20 bg-[#eee1ca]">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl md:text-5xl font-elegant font-bold text-black mb-4">
              {t('menu.commitments')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div data-aos="fade-up" className="text-center p-6">
              <div className="bg-[#72201e] text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                1
              </div>
              <h3 className="text-xl font-bold text-black mb-3">
                {t('menu.freshIngredients')}
              </h3>
              <p className="text-black">
                {t('menu.freshIngredientsDesc')}
              </p>
            </div>

            <div data-aos="fade-up" data-aos-delay="100" className="text-center p-6">
              <div className="bg-[#72201e] text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                2
              </div>
              <h3 className="text-xl font-bold text-black mb-3">
                {t('menu.authenticRecipes')}
              </h3>
              <p className="text-black">
                {t('menu.authenticRecipesDesc')}
              </p>
            </div>

            <div data-aos="fade-up" data-aos-delay="200" className="text-center p-6">
              <div className="bg-[#72201e] text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                3
              </div>
              <h3 className="text-xl font-bold text-black mb-3">
                {t('menu.varietyRenewal')}
              </h3>
              <p className="text-black">
                {t('menu.varietyRenewalDesc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl md:text-5xl font-elegant font-bold text-marrakech-dark mb-4">
              {t('menu.dishesInImages')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              '/images/DSC08521.webp',
              '/images/DSC08531.webp',
              '/images/DSC08535.webp',
              '/images/DSC08541.webp',
              '/images/DSC08566.webp',
              '/images/DSC08579.webp',
            ].map((image, index) => (
              <div
                key={index}
                data-aos="zoom-in"
                data-aos-delay={index * 50}
                className="image-zoom rounded-lg overflow-hidden shadow-lg"
              >
                <img
                  src={image}
                  alt={`Dish ${index + 1}`}
                  className="w-full h-64 sm:h-72 lg:h-80 object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Note Section */}
      

      {/* CTA Section */}
      <section className="py-20 bg-[#72201e] text-white">
        <div className="container mx-auto px-4 text-center" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-elegant font-bold mb-6">
            {t('menu.readyToDiscover')}
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            {t('menu.readyToDiscoverDesc')}
          </p>
          <a href="/reservation" className="btn-secondary bg-white text-marrakech-terracotta hover:bg-[#72201e] hover:text-white border-white">
            {t('menu.reserveNow')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Menu;

